import { FETCH_BENCHES_REQUEST, FETCH_BENCHES_SUCCESS, FETCH_BENCHES_FAILURE, FETCH_BENCH_VIDEOS_REQUEST, FETCH_BENCH_VIDEOS_SUCCESS, FETCH_BENCH_VIDEOS_FAILURE, START_LOADING, END_LOADING } from '../constants/actionTypes.js';

const initialState = {
  benches: [],
  bench: null,
  benchVideos: [],
  loading: false,
  error: null,
};

const benchReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, loading: true };

    case END_LOADING:
      return { ...state, loading: false };

    case FETCH_BENCHES_REQUEST:
    case FETCH_BENCH_VIDEOS_REQUEST:
      return { ...state, error: null };

    case FETCH_BENCHES_SUCCESS:
      return { ...state, benches: action.payload, error: null };

    case FETCH_BENCH_VIDEOS_SUCCESS:
      return { ...state, benchVideos: action.payload, error: null };

    case FETCH_BENCHES_FAILURE:
    case FETCH_BENCH_VIDEOS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default benchReducer;
